import React, {useEffect, useState} from 'react'
import {getAllStock} from "../../services/serviceStock";
import {DatePicker, Form, Input, Select} from "antd";
import moment from "moment";

const { Option } = Select

const PurchaseCostFilter = () => {

    const [stockList, setStockList] = useState([])

    useEffect(() => {
        getAllStock()
            .then(({data}) => {
                const stocks = data.map(stock => {
                    return {
                        value: stock.id,
                        text: `${stock.code} - ${stock.name}`
                    }
                })
                setStockList(stocks)
            })
    }, [])
    const month = 30 * ( 24 * 60 * 60 * 1000 )
    const today = new Date()

    return(
        <React.Fragment>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç Tarihi'}
                initialValue={moment(new Date(today - month))}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş Tarihi'}
                initialValue={moment(new Date())}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'id'}
                label={'Stok'}
                initialValue={''}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <Select

                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {
                        stockList.map(item => {
                            return <Option key={item.value} value={item.value} >{item.text}</Option>
                        })
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name={'bidCustomerName'}
                label={'Teklif Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'bidNumber'}
                label={'Teklif No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'purchaseNumber'}
                label={'Satın Alma No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            {/* <Form.Item
                name={'recipeCode'}
                label={'Reçete Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item> */}
            {/* <Form.Item
                name={'recipeCustomerName'}
                label={'Reçete Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item> */}
            <Form.Item
                name={'supplierName'}
                label={'Tedarikçi Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>

        </React.Fragment>
    )
}
export default PurchaseCostFilter